export const NIGHTANGLE_PAGE_CONFIG = {
  title: 'Realtime Revenue',
  titleCN: '实时收入',
  subTitle: 'Timezone (UTC{{timeZone}})',
  subTitleCN: '时区 (UTC{{timeZone}})',
  path: '/realtime/revenue',
  defaultTab: 'revenue',
  tabList: [
    {
      id: 'revenue',
      tabName: 'Revenue',
      tabNameCN: '收入',
      isHaveNotification: true,
      refresh: true,
      refreshConfig: {
        contentEn: 'Click to refresh or auto refresh every 10 minutes.',
        contentCn: '单击可刷新或每10分钟自动刷新一次.'
      },
      notificationPath: '/realtime/revenue',
      path: '/realtime/revenue',
      tabIcon: '',
      logConfig: {
        pageId: '200401',
        pageName: 'realtimeRealtimeRevenue',
        extInfo: 'realtimeRealtimeRevenue',
        pagePath: '/realtime/revenue',
      },
      filters: [
        {
          name: 'RealtimeRevenueFilter',
          isOpenSticky: false,
          isHaveFilterSave: true,
          filterPath: '/realtime/revenue',
          componentList: [
            {
              name: 'realtimeRevenueService',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/realtime/revenue_new',
                  isDark: true,
                  dataKey: 'revenue',
                  refreshKey:'realtime_user_revenue',
                  interval:600000
                }
              },
              children: [
                {
                  name: 'realtimeRevenueService',
                  className: '',
                  type: 'view',
                  style: {},
                  props: {
                    config: {
                      api: '/api/v1/dashboard/event_analysis/realtime/date_event_list',
                      isDark: true,
                      dataKey: 'date_event_list',
                      refreshKey:'realtime_user_date_event_list'
                    }
                  },
                  children: [
                    {
                      name: 'RealtimeRevenueContext',
                      props: {
                        config: {
                          title: 'Realtime Daily Accumulated Revenue (10 min)',
                          titleCn: '每日实时累计付费金额（10分钟）',
                          formatTitle: 'realtime_revenue_realtime_revenue_title',
                          explain:'Statistical Time: {{lastUpdateTime|string}} Due to the impact of midas data calculation and return time, the overall revenue data was delayed by about 40 minutes.',
                          explainCn:'统计时间: {{lastUpdateTime|string}} 受midas数据计算及回传时效影响，整体收入数据延迟约40分钟。',
                          apiDataKey: 'revenue',
                          dataType: 'money',
                          currencyUnit: '$',
                          className: "dbd-realtime-revenue-box",
                          noDataDisplay: true,
                          table: {
                            option: [{
                              key: 'time',
                              align: 'left',
                              fixed: 'left',
                              width: 100,
                              title: 'Time',
                              titleCn: '时间',
                              formatTitle: 'realtime_by_country_table_time',
                              valueKey: 'time'
                            }, {
                              key: 'line_dot',
                              align: 'right',
                              fixed: '',
                              width: 100,
                              title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                              titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}',
                              valueKey: 'lineDot',
                              format: '#,##0.00',
                              type: 'number'
                            }, {
                              key: 'line_dot_last',
                              align: 'right',
                              fixed: '',
                              width: 100,
                              title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                              titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                              valueKey: 'lineDotLast',
                              format: '#,##0.00',
                              type: 'number'
                            }, {
                              key: 'line_dot_contrast',
                              align: 'right',
                              fixed: '',
                              width: 100,
                              title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day',
                              titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日',
                              valueKey: 'lineDotContrast',
                              changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                              changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                              format: '#,##0.00',
                              type: 'number'
                            }],
                            sort: true,
                            columns: ['time'],
                            defaultValue: [{ by: 'time', order: 'desc' }],
                            isRealTime: true,
                            height: 350
                          },
                          subTitle: [{
                            title: 'DoD',
                            titleCn: '日环比',
                            formatTitle: '',
                            valueKey: 'dod',
                            unit: 'percent',
                            bold: true
                          }, {
                            title: 'SDLW',
                            titleCn: '上周同期',
                            formatTitle: '',
                            valueKey: 'sdlw',
                            unit: 'percent',
                            bold: true
                          }],
                          event: {
                            show: true,
                            link: 'eventAnalysis/eventDetails',
                            dataKey: 'date_event_list',
                            timeType: 'Hour',
                            cssStyle: { top: '82%' }
                          },
                          chart: {
                            type: 'line',
                            series: [{
                              valueKey: 'line_dot',
                              title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                              titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}'
                            }, {
                              valueKey: 'line_dot_last',
                              title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                              titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',

                            }, {
                              valueKey: 'line_dot_contrast',
                              title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)',
                              titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)',
                              changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                              changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                            }],
                            tooltip: {
                              title: 'Revenue($)',
                              titleCn: '付费金额($)',
                              formatTitle: 'realtime_revenue'
                            },
                            height: 350
                          },
                          download: {
                            fileName: 'Realtime Daily Accumulated Revenue (10 min)',
                            fileNameCn: '每日实时累计付费金额（10分钟）',
                            formatFileName: 'realtime_revenue_realtime_revenue_download',
                            default: '10',
                            title: 'Time',
                            titleCn: '时间粒度',
                            formatTitle: 'realtime_info_download_time',
                            type: [
                              {
                                title: 'By hour',
                                titleCn: '下载逐小时数据',
                                formatTitle: 'realtime_info_download_by_hour',
                                name: '60',
                                disable: 'l1h',
                                beforeDownload: 'hourDownload'
                              },
                              {
                                title: 'By 10 min',
                                titleCn: '下载每10 min数据',
                                formatTitle: 'realtime_info_download_by_10_min',
                                name: '10',
                                beforeDownload: ''
                              }
                            ],
                            sorting: false,
                            sort: 'desc'
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            },
          ]
        },
      ],
    },
  ]
}